import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { FaArrowUp } from "react-icons/fa";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import MediumBand from "./components/MediumBand";

function App() {
  const [isVisible, setisVisible] = useState(false);
  const scrollToTop = () => {
    if (window.scrollY > 200) {
      setisVisible(true);
    } else {
      setisVisible(false);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", scrollToTop);
    return () => {
      window.removeEventListener("scroll", scrollToTop);
    };
  }, []);
  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Skills />
      <Projects />
      <Contact />
      {isVisible && (
        <motion.button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          whileHover={{ scale: 1.05, originX: 0, color: "#f8e112" }}
          animate={{
            y: [0, -10, 0],
          }}
          transition={{
            y: {
              duration: 1,
              repeat: Infinity,
              repeatType: "loop",
              ease: "easeInOut",
            },
          }}
          style={{
            position: "fixed",
            width: "60px",
            height: "60px",
            bottom: "1.5rem",
            right: "1rem",
            backgroundColor: "#766c82",
            color: "#ffffff",
            fontWeight: "500",
            fontSize: "0.875rem",
            padding: "1rem",
            borderRadius: "100%",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <FaArrowUp size={32} />
        </motion.button>
      )}
      <MediumBand />
      <Footer />
    </div>
  );
}

export default App;
